import { render, staticRenderFns } from "./ActionsView.vue?vue&type=template&id=bea70898&lang=pug"
import script from "./ActionsView.vue?vue&type=script&lang=ts"
export * from "./ActionsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bea70898')) {
      api.createRecord('bea70898', component.options)
    } else {
      api.reload('bea70898', component.options)
    }
    module.hot.accept("./ActionsView.vue?vue&type=template&id=bea70898&lang=pug", function () {
      api.rerender('bea70898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/actions/Actions/ActionsView.vue"
export default component.exports